import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const KioskRoute = ({ children }) => {
  const { tenantCode } = useParams();
  const kioskToken = localStorage.getItem('kiosk_token');

  if (!kioskToken) {
    return <Navigate to={`/app/${tenantCode}/kiosk/activate`} replace />;
  }

  return children;
};

export default KioskRoute;
